'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _AbstractReactComponent = require('./../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

var _reactstrap = require('reactstrap');

var _Utils = require('./../Utils2');

var _i18n = require('./../i18n/i18n');

var _i18n2 = _interopRequireDefault(_i18n);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

require("./FormBody.scss");

var FormBody = function (_AbstractReactCompone) {
    (0, _inherits3.default)(FormBody, _AbstractReactCompone);

    function FormBody() {
        (0, _classCallCheck3.default)(this, FormBody);
        return (0, _possibleConstructorReturn3.default)(this, (FormBody.__proto__ || (0, _getPrototypeOf2.default)(FormBody)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormBody, [{
        key: 'getChildContext',
        value: function getChildContext() {
            var _props = this.props,
                fieldLabelPrefix = _props.fieldLabelPrefix,
                formPath = _props.formPath;


            return { fieldLabelPrefix: fieldLabelPrefix, formPath: formPath };
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                cards = _props2.cards,
                children = _props2.children,
                required = _props2.required,
                style = _props2.style;
            var isModal = this.context.isModal;


            var requiredInfo = void 0;
            if (required) {
                requiredInfo = _react2.default.createElement(
                    'div',
                    { className: 'required-fields-info' },
                    (0, _i18n2.default)("global.form.title.contains.required.fields")
                );
            }

            var cls = (0, _classnames2.default)("form-content-container", {
                "cards": cards
            });

            if (isModal) {
                return _react2.default.createElement(
                    _reactstrap.ModalBody,
                    { className: cls, style: style },
                    children,
                    requiredInfo
                );
            } else {
                return _react2.default.createElement(
                    'div',
                    { className: cls, style: style },
                    children,
                    requiredInfo
                );
            }
        }
    }]);
    return FormBody;
}(_AbstractReactComponent2.default);

FormBody.contextTypes = {
    isModal: _react2.default.PropTypes.bool
};
FormBody.PropTypes = {
    fieldLabelPrefix: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array]),
    formPath: _react2.default.PropTypes.string,
    required: _react2.default.PropTypes.bool,
    cards: _react2.default.PropTypes.bool, // pokud je tru, jedná se o dialog, na kterém jsou logické sekce jako karty
    children: _Utils.COMPONENT_CHILDREN
};
FormBody.defaultProps = {
    formPath: ""
};
FormBody.childContextTypes = {
    fieldLabelPrefix: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.string, _react2.default.PropTypes.array]),
    formPath: _react2.default.PropTypes.string
};
exports.default = FormBody;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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